export function PageTitle({ children }: { children: React.ReactNode }) {
    return (
        <h1 className="text-l md:text-xl font-semibold tracking-tight text-foreground">
            {children}
        </h1>
    );
}